import ApiService from '@/services/ApiService';

export default {
  getAll() {
    return ApiService().get('/product/list');
  },
  printReportArticles(useStation) {
    if (useStation) {
      return ApiService().post('/product/print-report-by-workday?useStation=1');
    } 
    return ApiService().post('/product/print-report-by-workday');
  },
  convertColor(mi) {
    if (!mi) {
      return '';
    }

    const red = parseInt(mi / 65536, 10);
    const green = parseInt((mi - red * 65536) / 256, 10);
    const blue = mi - red * 65536 - green * 256;

    let r16 = red.toString(16);
    while (r16.length < 2) {
      r16 = `0${r16}`;
    }
    let g16 = green.toString(16);
    while (g16.length < 2) {
      g16 = `0${g16}`;
    }
    let b16 = blue.toString(16);
    while (b16.length < 2) {
      b16 = `0${b16}`;
    }
    return `#${(r16 + g16 + b16).toUpperCase()}`;
  },

  setCommission(product, products, commissions) {
    let commissionId = null;
    if(product.commission) {
      commissionId = product.commission;
    }
    if(product.managementGroup && product.managementGroup.commission) {
      commissionId = product.managementGroup.commission;
    }
    if(product.category && product.category.commission) {
      commissionId = product.category.commission;
    }
    if(!commissionId) return null;
    return commissions.find(({ id }) => id === commissionId);
  },

  setMixer(product, products, mixerGroups) {
    let mixerGroupId = null;
    if(product.mixerGroup) {
      mixerGroupId = product.mixerGroup;
    } else if(product.managementGroup && product.managementGroup.mixerGroup) {
      mixerGroupId = product.managementGroup.mixerGroup;
    } else if(product.category && product.category.mixerGroup) {
      mixerGroupId = product.category.mixerGroup;
    }
    if(!mixerGroupId) return [];
    const mixers = [];
    const mixerGroup = mixerGroups.find(({ id }) => id === mixerGroupId);
    if(mixerGroup.products) {
      mixerGroup.products.forEach(mixer => {
        const product = products.find(({ id }) => id === mixer);
        if(product) {
          mixers.push({
            id: product.id,
            name: product.name,
            price: product.price,
            color: this.convertColor(product.color),
          });
        }
      });
    }
    return mixers;
  }

};
